import { Outlet } from "react-router-dom";
import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";
import { usePlatformStore } from "@platform/store";
import DashboardLayout from "./DashboardLayout";
import MarketingLayout from "./MarketingLayout";

export type Props = {
  title: string;
};

export function StaticPageLayout({ title }: Props) {
  const user = usePlatformStore((s) => s.user);

  const Layout = !!user ? DashboardLayout : MarketingLayout;

  return (
    <Layout title={title}>
      <OuterContentContainer
        className="flex-1 flex flex-col items-center justify-center"
        innerClassName="flex-1"
      >
        <Outlet />
      </OuterContentContainer>
    </Layout>
  );
}

export default StaticPageLayout;
